<div
  class="media"
  [formGroup]="textForm"
  [ngClass]="[preview || !hasEdit ? 'preview' : '']"
>
  <div style="width: 100%; height: 100%">
    <ng-container *ngIf="canvasMode == 'edit'">
      <div id="{{ divID }}"></div>
      <editor
        (onSelectionChange)="handleEvent($event)"
        [apiKey]="apiTinymce"
        formControlName="text"
        [init]="optionsTinymce"
        style="overflow: scroll"
      ></editor>
    </ng-container>
    <ng-container *ngIf="canvasMode != 'edit'">
      <editor
        [apiKey]="apiTinymce"
        formControlName="text"
        [init]="optionsTinymce"
        [disabled]="true"
        style="overflow: scroll; height: 90%"
      ></editor>
    </ng-container>
  </div>
</div>
